import { useState } from "react"
import { Alert, Tab, Tabs } from "@mui/material"
import { JoinTab, TdataOnboardingTab } from "../components/massOps"
import { useMassOpsRunner } from "../components/massOps/useMassOpsRunner"
import { UserbotPage } from "./userbotPage"

export function MassOpsPage() {
  const [tab, setTab] = useState(0)
  const snapshot = useMassOpsRunner()

  return (
    <UserbotPage title="Массовые операции">
      {snapshot.hasActive && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Идут массовые операции: {snapshot.completed + snapshot.failed}/
          {snapshot.total} — не закрывайте и не обновляйте вкладку
        </Alert>
      )}
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab label="Импорт tdata" />
        <Tab label="Массовое вступление" />
      </Tabs>
      {tab === 0 && <TdataOnboardingTab />}
      {tab === 1 && <JoinTab />}
    </UserbotPage>
  )
}
